import React from "react";
import "./styles.css";
import Exo from "./components/exo";
import { cours } from "./exos/exos";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import GithubCorner from "react-github-corner";
import { Grid } from "@mui/material";
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

function HomeIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
        </SvgIcon>
    );
}

const drawerWidth = 240;

export default function App(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [selectedExo, setSelectedExo] = React.useState(null);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const container =
        window !== undefined ? () => window().document.body : undefined;

    const exercise = (e: any) => {
        return <ListItem key={e.questions[0]} disablePadding>
            <ListItemButton disableRipple selected={selectedExo === e} onClick={(_) => { setSelectedExo(e); setMobileOpen(false) }}>
                Exercice : {e.name}
            </ListItemButton>
        </ListItem>
    }

    const drawer = (
        <div>
            <List>
                {cours.map((c) => (
                    <div>
                        <ListItem key={c.name} disablePadding>
                            <ListItemText primary={
                                <Grid container justifyContent="center" alignItems="center" sx={{ fontWeight: 'bold' }}>
                                    <Typography style={{ fontWeight: "bold" }}>{c.name}</Typography>
                                </Grid>
                            } />
                        </ListItem>
                        <ListItem key={c.name + '2'} disablePadding>
                            <ListItemButton disableRipple selected={selectedExo === c} onClick={(_) => { setSelectedExo(c); setMobileOpen(false) }}>
                                Cours
                            </ListItemButton>
                        </ListItem>
                        {c.exos.map(exercise)}
                        <Divider sx={{ border: 1 }} />
                    </div>
                ))}
            </List>
        </div>
    );

    let main = (<div>
        Ce site propose des cours et exercices interactifs pour apprendre SQL et comprendre le fonctionnement des bases de données.
        <br />
        Il est conforme au programme de CPGE (filières MP2I, MP, PC, PSI, PT, BCPST).
        <br />
        <b>Attention : dans vos réponses, les colonnes doivent apparaître dans le même ordre que dans la question.</b><br />
        <a href="https://github.com/mpi-informatique/sql/issues">Signaler un problème</a><br />
        <a href="https://github.com/fortierq/datasets">Bases de données utilisées</a><br />
        <a href="https://github.com/mpi-informatique/sql/tree/main/src/exos">Contribuer en ajoutant un exercice ou des questions (par pull request)</a><br />
        <a href="https://fortierq.github.io/teaching">Mes autres cours</a><br />
        <a href="https://mpi-lamartin.github.io/mpi-info">Cours d'informatique en MPI</a>
    </div>)
    if (selectedExo) {
        if ('url' in selectedExo)
            main = (<iframe src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=https://raw.githubusercontent.com/fortierq/cours/main/sql/${selectedExo.url}#zoom=page-fit&pagemode=none`} width="100%" height="700" />)
        else
            main = (<Exo key={selectedExo.questions[0]} {...selectedExo} />)
    }
    return (
        <div>
            <Box sx={{ display: "flex" }}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    sx={{
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                        ml: { sm: `${drawerWidth}px` },
                        height: 60,
                    }}
                >
                    <Toolbar>
                        <GithubCorner
                            href="https://github.com/mpi-informatique/sql"
                            direction="right"
                            size="60"
                        />
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: "none" } }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <IconButton
                            disableRipple
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={(_) => { setSelectedExo(null) }}
                            sx={{ mr: 1 }}
                        >
                            <HomeIcon fontSize="large" />
                        </IconButton>
                        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, fontSize: { xs: "1rem", sm: "1.25rem" } }}>
                            {/* {selectedExo ? selectedExo : "Cours de bases de données et exercices SQL"} */}
                            Cours et exercices SQL
                        </Typography>
                        <Button component="a" href="https://mpi-informatique.github.io/" color="inherit" title="MPI Informatique" sx={{ ml: 1, mr: "48px", minWidth: 44, fontWeight: 700 }}>MPI</Button>
                    </Toolbar>
                </AppBar>

                <Box
                    component="nav"
                    sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                >
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        sx={{
                            display: { xs: "block", sm: "none" },
                            "& .MuiDrawer-paper": {
                                boxSizing: "border-box",
                                width: drawerWidth,
                            },
                        }}
                    >
                        {drawer}
                    </Drawer>
                    <Drawer
                        variant="permanent"
                        sx={{
                            display: { xs: "none", sm: "block" },
                            "& .MuiDrawer-paper": {
                                boxSizing: "border-box",
                                width: drawerWidth,
                                border: 1.5,
                            },
                        }}
                        open
                    >
                        {drawer}
                    </Drawer>
                </Box>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                    }}
                >
                    <Toolbar />
                    {main}
                </Box>
            </Box>
        </div>
    );
}
